import { render, staticRenderFns } from "./swiper.vue?vue&type=template&id=5e1d9b3f&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"
import style0 from "./swiper.vue?vue&type=style&index=0&id=5e1d9b3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d9b3f",
  null
  
)

export default component.exports